import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Badge, Spinner, EmptyState, PageHeader } from '../components/Common';
import { API_URL } from '../config';

const API = `${API_URL}/contact`;
const getToken = () => localStorage.getItem('bhamsa_sa_token');

const SuperAdminLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setLeads(res.data.messages || []);
    } catch (err) {
      toast.error('Leads load nahi ho paye');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const toggleRead = async (id) => {
    try {
      await axios.put(`${API}/${id}/toggle-read`, {}, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setLeads(leads.map(l => l.id === id ? { ...l, is_read: !l.is_read } : l));
    } catch (err) {
      toast.error('Update fail ho gaya');
    }
  };

  const filtered = leads.filter(l =>
    (l.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (l.email || '').toLowerCase().includes(search.toLowerCase()) ||
    (l.company || '').toLowerCase().includes(search.toLowerCase())
  );

  const unreadCount = leads.filter(l => !l.is_read).length;

  if (loading) return <Spinner />;

  return (
    <div className="page">
      <PageHeader
        title={`📥 Leads ${unreadCount > 0 ? `(${unreadCount} new)` : ''}`}
        subtitle="Landing page ke contact form se aayi hui saari inquiries"
      />

      <div className="form-group" style={{ maxWidth: 320, marginBottom: 20 }}>
        <input
          className="form-input"
          placeholder="🔍 Search by name, email, company..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {filtered.length === 0 ? (
        <EmptyState icon="📭" title="Koi lead nahi mila" message="Jaise hi koi contact form submit karega, yahan dikhega." />
      ) : (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Company</th>
                  <th>Message</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(lead => (
                  <tr key={lead.id} style={{ background: lead.is_read ? 'transparent' : 'rgba(108,99,255,0.05)' }}>
                    <td>
                      {lead.is_read
                        ? <Badge variant="gray">Read</Badge>
                        : <Badge variant="blue">New</Badge>}
                    </td>
                    <td style={{ fontWeight: 600 }}>{lead.name}</td>
                    <td>
                      <a href={`mailto:${lead.email}`} style={{ color: 'var(--accent2)' }}>{lead.email}</a>
                    </td>
                    <td>{lead.company || '—'}</td>
                    <td style={{ maxWidth: 260, whiteSpace: 'normal' }}>{lead.message || '—'}</td>
                    <td style={{ whiteSpace: 'nowrap', fontSize: 12, color: 'var(--text3)' }}>
                      {new Date(lead.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                      <br />
                      {new Date(lead.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}
                    </td>
                    <td>
                      <button className="btn btn-ghost btn-sm" onClick={() => toggleRead(lead.id)}>
                        {lead.is_read ? '↩ Mark Unread' : '✓ Mark Read'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperAdminLeads;